import ContactCreate from './ContactCreate';

export default ContactCreate;
